<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-6 ">
        <h1>Profile</h1>
      </div>
      <div class="col-md-6">
        <v-button-group is-right>
          <v-button
            size="lg"
            color="secondary"
            has-min-width
            @click="changePassword"
          >
            Change Password
          </v-button>
          <v-button
            size="lg"
            has-min-width
            @click="editProfile"
          >
            Edit Profile
          </v-button>
        </v-button-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 d-flex">
        <v-card title="Details">
          <v-definition-list
            :data="updateDetails"
          />
        </v-card>
      </div>
      <div class="col-md-6 d-flex">
        <v-card title="Address Details">
          <v-definition-list
            :data="updateBillingDetails"
          />
        </v-card>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex">
          <strong>Notes:</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex">
          <ul>
            <li>The above email will be used as the primary contact for all NATA correspondence</li>
            <li>Above address details are for registration/identification purpose only, any changes made to the profile details will only appear on the profile once approved by NATA.</li>
            <li>
              To change the appointed Authorised Representative or Facility details please complete the <a
                href="https://www.nata.com.au/phocadownload/gen-accreditation-forms/Facility-Details-Update-Form-FDU.pdf"
                target="_blank"
                class="btn--secondary"
                download="Facility-Details-Update-Form-FDU.pdf"
              >Facility Details Update (FDU)</a> form and upload it on the Portal at the Site level or email us the form on <a
                :href="getEmail(true)"
                class="btn--secondary"
              >{{ getEmail() }}</a>.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Card from "@/molecules/Card";
  import DefinitionList from "@/atoms/DefinitionList";
  import {buildBreadCrumb, buildDefinitionList} from "@/common/tableFunctions";
  import routes from "@/common/routes";
  import constants from "@/common/constants";

  export default {
    name: "Profile",
    components: {
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-card': Card,
      "v-definition-list": DefinitionList,
      PageTemplate
    },
    computed: {
        updateDetails: function() {
            let details  = [];
            let user = this.$store.getters.getUser;

            details['Name'] = user.first_name;
            details['Last Name'] = user.last_name;
            details['Email Address'] = user.email;
            details['Phone'] = user.mobile_number;
            return buildDefinitionList(details);

        },
        updateBillingDetails: function(){
            let billing_details = [];
            let user = this.$store.getters.getUser;
            billing_details['Address'] = user.address;
            billing_details['Suburb'] = user.suburb;
            billing_details['Country'] = user.country;
            billing_details['State'] = user.state;
            billing_details['Post Code'] = user.postcode;
            return buildDefinitionList(billing_details);
        }
      },
    mounted(){
      this.updateBreadCrumb();
    },
    methods:{
        updateBreadCrumb: function() {
            let breadcrumbs = [];
            breadcrumbs['Dashboard'] = routes.DASHBOARD;
            breadcrumbs['Profile'] = '';
            this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
        },
        changePassword:function () {
            this.$router.push(routes.CHANGE_PASSWORD)
        },
        editProfile: function(){
            this.$router.push(routes.EDIT_PROFILE)
        },
        getEmail(isLink) {
        if(isLink)
          return "mailto:"+constants.NATA_CONTACTS.EMAIL;
        return constants.NATA_CONTACTS.EMAIL;
      }
    }
  }
</script>

